<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { vMuted } from "#/directives/vMuted";
import { useScreenBackground } from "#/hooks/useScreenBackground/useScreenBackground";
import { useThemeStore } from "#/store/theme";

const props = defineProps<{ isKiosk?: boolean }>();

const themeStore = useThemeStore();
const { mediaUrl, videoMimeType, isImage } = useScreenBackground(() => !!props.isKiosk);

const { t } = useTranslation();
</script>

<template>
	<div class="fiscal_wrapper">
		<img v-if="mediaUrl && isImage" :key="mediaUrl" class="fiscal_background" :src="mediaUrl" alt="" crossorigin="anonymous">
		<video v-else-if="mediaUrl" :key="mediaUrl" loop autoplay muted playsinline v-muted crossorigin="anonymous">
			<source :src="mediaUrl" :type="videoMimeType">
		</video>
		<div class="fiscal_container">
			<div class="fiscal_stage" aria-hidden="true">
				<div class="fiscal_printer">
					<div class="fiscal_led"></div>
					<div class="fiscal_slot"></div>
					<div class="fiscal_receipt">
						<div class="fiscal_tear"></div>
						<img v-if="themeStore.data?.logo" class="fiscal_logo_img" :src="themeStore.data?.logo || ''" alt="Logo">
						<div class="fiscal_line accent"></div>
						<div class="fiscal_line"></div>
						<div class="fiscal_line sm"></div>
						<div class="fiscal_line"></div>
						<div class="fiscal_line sm"></div>
						<div class="fiscal_line"></div>
						<div class="fiscal_line sm"></div>
					</div>
				</div>
			</div>
			<h1 class="fiscal_title_fiscal">{{ t(`cart-complete.fiscal.title`) }}</h1>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@use './cartCompleteFiscal.scss';
</style>
